export const PROCESSING_CONFIG = {
  // Video processing
  targetFPS: 30,
  minFPS: 24,
  maxFPS: 60,
  minResolution: { width: 1280, height: 720 },
  minDuration: 15, // seconds
  maxDuration: 60, // seconds
  
  // Frame extraction
  frameSkip: 1, // Process every Nth frame (1 = all frames)
  
  // Marker detection
  markerDetection: {
    minConfidence: 0.5,
    maxMissingFrames: 5,
    interpolationMethod: 'kalman'
  },
  
  // Pose estimation
  poseEstimation: {
    model: 'movenet', // 'movenet' or 'blazepose'
    minConfidence: 0.3,
    smoothingWindow: 5,
    maxGapFrames: 3
  },
  
  // Phase calculation
  phaseCalculation: {
    ellipseFitWindow: 10, // seconds
    ransacIterations: 100,
    ransacThreshold: 10,
    minCadence: 40, // rpm
    maxCadence: 140, // rpm
    steadyStateThreshold: 0.1 // cadence variation
  },
  
  // Phase binning
  phaseBinning: {
    binSize: 5, // degrees
    fineBinSize: 2, // degrees (for TDC/BDC)
    minSamplesPerBin: 3
  },
  
  // Quality thresholds
  quality: {
    minTrackingRate: 0.85,
    minPoseConfidence: 0.6,
    minPhaseQuality: 0.7,
    framingMargin: 0.05 // 5% from edge
  },
  
  // Web Workers
  useWebWorkers: true,
  maxWorkers: 4
};

export const UI_CONFIG = {
  colors: {
    primary: '#2563eb',
    success: '#16a34a',
    warning: '#ea580c',
    error: '#dc2626',
    info: '#0891b2'
  },
  
  qualityColors: {
    excellent: '#16a34a',
    good: '#16a34a',
    acceptable: '#ea580c',
    poor: '#dc2626'
  },
  
  chartDefaults: {
    lineWidth: 2,
    pointSize: 0,
    showLegend: true,
    showGrid: true
  }
};
